import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private menuActionCompleted = new Subject<void>();
  private helpClosed = new Subject<void>();
  private newCBRecord = new Subject<void>();
  private clipboardEntity: Subject<string> = new Subject();

  private _clearEntityEvent = new Subject();
  public clearEntityEvent = this._clearEntityEvent.asObservable();

  private navigationState = { previousUrl: '/', currentUrl: '/' };

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.navigationState.previousUrl = this.navigationState.currentUrl;
      this.navigationState.currentUrl = event.url;
    });
  }

  public notifyClipboardEntity(value: string) {
    this.clipboardEntity.next(value);
  }

  public getClipboardEntity(): Observable<string> {
    return this.clipboardEntity.asObservable();
  }

  public getUrlFragment() {
    return this.route.fragment.pipe(map(frag => (!!frag ? frag.toString().toLowerCase() : frag)));
  }

  public getMenuActionCompleted(): Observable<any> {
    return this.menuActionCompleted.asObservable();
  }

  public setMenuActionCompleted(): void {
    this.menuActionCompleted.next();
  }

  public getHelpClosed(): Observable<any> {
    return this.helpClosed.asObservable();
  }

  public setHelpClosed(): void {
    this.helpClosed.next();
  }

  public getNewCBRecord() {
    return this.newCBRecord.asObservable();
  }

  public setNewCBRecord() {
    this.newCBRecord.next();
  }

  public sendClearEntity(entity) {
    this._clearEntityEvent.next(entity);
  }

  public getNavigationState() {
    return this.navigationState;
  }
}
